import { toFormat } from 'core/classes/helpers/DateHelper'

/* A recalculation is requested and finished within the day as a rule, so today's moment is named
   by its time alone. */
export const formatRecalcDate = (value: string) =>
  toFormat(
    value,
    toFormat(value, 'YYYY-MM-DD') === toFormat(new Date(), 'YYYY-MM-DD')
      ? 'HH:mm'
      : 'DD MMM YYYY, HH:mm'
  )
